import { faUser } from "@fortawesome/free-solid-svg-icons";


export const dashboardRoutes = {
    label: 'Dashboard',
    labelDisable: true,
    onlyAdmin: false,
    children: [
        // {
        //     name: 'edi.navbar.routes.default',
        //     to: '/',
        //     exact: true,
        //     active: true,
        //     icon: faHome
        // },
        {
            name: 'main.navbar.routes.admin',
            to: '/admin',
            active: true,
            onlyAdmin: true,
            icon: faUser
        },
    ]
}

export const adminRoutes = {
    label: 'Admin',
    to: '/admin',
    onlyAdmin: true,
    children: [
        {
            name: 'admin.navbar.routes.organizations',
            icon: 'users',
            to: '/admin/organizations',
            active: true
        },
        {
            name: 'admin.dashboard.desktop_app_versions.title',
            icon: 'users',
            to: '/desktop-app/versions',
            active: true
        },
    ]
}


const routes = [
    dashboardRoutes,
];


routes.push(adminRoutes);


// Todo: if a marketplaceRoutes is added, it must have "to" in its property => to: "/marketplace"

export default routes;
